// extracted by mini-css-extract-plugin
export default {"glyphOpticalAdjustment":"CreatePassword_glyphOpticalAdjustment__zEXci"};